import { ProductCardSize } from '@services/MarppleShop/features/ProductList/type/index.ts';
import { html as htmljs, go, filter } from 'fxjs/es';
import { html } from 'rune-ts';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { ProductCardListView } from '@services/MarppleShop/renderApp/components/cells/ProductCardList/ProductCardListView.ts';
import { FanLetterListView } from '../../../../../../../services/MarppleShop/renderApp/components/cells/FanLetterList/FanLetterListView.ts';
import { SectionTitle } from '../../../../../../../services/MarppleShop/renderApp/components/cells/SectionTitle/SectionTitle.ts';
import { makeFanLetterMoreLinkPlugin } from './fanLetter.ts';
import { unEscaper } from '../../../../../../../shared/utils/escape.ts';
import { SeeMoreLinkPlugin } from '@services/MarppleShop/renderApp/components/cells/SectionTitle/plugins/index.ts';
import { makeEmptyScreenNavigate } from '@services/MarppleShop/shared/app/navigate.ts';

export const makeRecommendProductsHtml = ({ store, mps_recommended_products, product_detail, is_mobile }) => {
  const recommend_products = go(
    mps_recommended_products?.products || [],
    filter((product) => product.id !== product_detail.id),
  );

  return UtilS.htmlIf2(
    recommend_products?.length,
    () => htmljs`
    <div tab_name="recommend" class="pd-contents__group">
       <div class="pd-recommend-and-fan-letter">
          <ul
            class="pd-recommend-and-fan-letter__container pd-recommend-and-fan-letter__container--recommend"
          >
          <div class="pd-recommend-and-fan-letter__heading">
          ${new SectionTitle({
            ssr: true,
            title_props: {
              title: html.preventEscape(
                ET('product_detail::recommend_and_fan_letter::recommend_title', {
                  emphasis: unEscaper(store?.name || ''),
                }),
              ),
              size: is_mobile ? 'xSmall' : 'medium',
            },
            plugins: [
              new SeeMoreLinkPlugin({
                see_more_link: `/${ET.lang}/${store.domain_name}/products`,
                navigate: makeEmptyScreenNavigate(`/${ET.lang}/${store.domain_name}/products`),
                size: is_mobile ? 'xSmall' : 'medium',
              }),
            ],
          }).toHtmlSSR()}
           </div>
            <div class="pd-recommend-and-fan-letter__wrapper">
              ${new ProductCardListView(
                // 타입 추론을 위해 풀어서 씀
                { products: recommend_products.slice(0, is_mobile ? 8 : 4) },
                {
                  resize_width: is_mobile ? 218 : 432,
                  size: is_mobile ? ProductCardSize.xSmall : ProductCardSize.medium,
                  is_lazy: true,
                  container_klass: 'pd-recommend-and-fan-letter__recommend',
                  hide_badges: false,
                  card_klass: 'pd-recommend-and-fan-letter__recommend--card',
                },
              ).toHtmlSSR()}
            </div>
          </ul>
      </div>
    </div>
    `,
    () => htmljs`
    <div tab_name="recommend" class="pd-contents__group"></div>
    `,
  );
};

export const makeFanletterHtml = ({ store, fan_letters, is_mobile, is_login }) => {
  return htmljs`
    <div class="pd-recommend-and-fan-letter">
      <div class="pd-recommend-and-fan-letter__container pd-recommend-and-fan-letter__container--fan">
        <div class="pd-recommend-and-fan-letter__heading--fan">
          ${new SectionTitle({
            ssr: true,
            title_props: {
              title: html.preventEscape(
                ET(`creator_shop::fan_letters::pd_title_02`, {
                  store_name: unEscaper(store?.name || ''),
                }),
              ),
              size: is_mobile ? 'xSmall' : 'medium',
            },
            plugins: [makeFanLetterMoreLinkPlugin(store.domain_name, is_mobile)],
          }).toHtmlSSR()}
        </div>
        <div class="pd-recommend-and-fan-letter__wrapper">
          ${new FanLetterListView({
            fan_letters: fan_letters.slice(0, is_mobile ? 8 : 3),
            is_login,
            creator: store,
            list_type: 'horizontal',
            is_mobile,
            item_mode: 'Large',
            grid_columns: 4,
            klass: 'pd-recommend-and-fan-letter__view',
          }).toHtmlSSR()}
        </div>
      </div>
    </div>
  `;
};
